import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueTouch from 'vue-touch'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

Vue.use(Vant)
Vue.use(ViewUI)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(VueResource)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js